import useCascaderNew from "./use-cascader.new.js";
import useCascaderOld from "./use-cascader.old.js";
function useCascader({ data, ...restOptions }) {
    const useCompatibleCascader = data ? useCascaderNew : useCascaderOld;
    return useCompatibleCascader({
        data,
        ...restOptions,
    });
}
export default useCascader;
